import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { CmsActivatedRouteSnapshot } from '@spartacus/core';
import { map, switchMap } from 'rxjs/operators';
import { GlobalSearchResult } from '../models';
import { BaseStoreService, GlobalSearchService } from '../services';

@Injectable({
  providedIn: 'root'
})
export class SearchResultGuard implements CanActivate {
  query: string;
  constructor(
    private router: Router,
    private globalSearchService: GlobalSearchService,
    private baseStoreService: BaseStoreService
  ) {}

  canActivate(route: CmsActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const paramsWithAllTargets = {
      query: route.queryParamMap.get('query'),
      target: 'product,accessoryProduct',
      pageSize: 9
    };
    if (!this.query || this.query !== paramsWithAllTargets.query) {
      this.query = paramsWithAllTargets.query;
    } else if (this.query === paramsWithAllTargets.query) {
      return of(true);
    }
    const mapProductUrl = map((search: GlobalSearchResult) => {
      const queryText = route.queryParamMap.get('text');
      const productUrl = [...search.accessorySearchPageData.products, ...search.productSearchPageData.products].find(
        (productResult) => new RegExp(`(${productResult.code}|${productResult.commercialCode})`, 'i').test(queryText)
      )?.url;
      return productUrl ? this.router.parseUrl(productUrl) : this.redirectToUrl(search);
    });
    const mapRedirecturl = map((search: GlobalSearchResult) => this.redirectToUrl(search));
    const search$: Observable<GlobalSearchResult> = this.globalSearchService.globalSearch(paramsWithAllTargets);

    return this.baseStoreService
      .getBaseStore()
      .pipe(
        switchMap((baseStore) =>
          search$.pipe(baseStore.isSearchRedirectionByCMMFAndRefEnabled ? mapProductUrl : mapRedirecturl)
        )
      );
  }

  private redirectToUrl(search: GlobalSearchResult) {
    if (search.productSearchPageData?.keywordRedirectUrl?.split('/').length) {
      if (/http(s)?:\/\//.test(search.productSearchPageData.keywordRedirectUrl)) {
        window.location.href = search.productSearchPageData.keywordRedirectUrl;
        return true;
      }
      return this.router.parseUrl(search.productSearchPageData.keywordRedirectUrl);
    }
    if (search.accessorySearchPageData?.keywordRedirectUrl?.split('/').length) {
      if (/http(s)?:\/\//.test(search.productSearchPageData.keywordRedirectUrl)) {
        window.location.href = search.accessorySearchPageData.keywordRedirectUrl;
        return true;
      }
      return this.router.parseUrl(search.accessorySearchPageData.keywordRedirectUrl);
    }
    return true;
  }
}
